import styled from 'styled-components';
import { CustomCheckbox } from '../../Checkbox/style';

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 246px 1fr;
  gap: 44px;
  height: calc(100% - 42px);

  .type-wrapper {
    border-left: 1px solid ${(props) => props.theme.colors.link};
    padding-left: 32px;
  }

  .no-course-msg {
    grid-column-end: span 2;
  }
`;

export const TypeSelector = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  padding: 8px;
  padding-left: 24px;
  color: ${(props) => props.theme.colors.link};
  cursor: pointer;

  ${CustomCheckbox} {
    bottom: -13px;
  }

  &.select-all {
    padding-bottom: 16px;
    border-bottom: 1px solid ${(props) => props.theme.colors.link};
    color: ${(props) => props.theme.colors.textPrimary};
    cursor: default;
  }

  &.active {
    background-color: ${(props) => props.theme.colors.bgBox};
    font-weight: 600;
    border-radius: 4px;
    position: relative;
    > div {
      color: ${(props) => props.theme.colors.link} !important;
      cursor: default;
    }

    &::before {
      content: '';
      width: 3px;
      height: 24px;
      background-color: ${(props) => props.theme.colors.bgFooter};
      position: absolute;
      left: 12px;
    }
  }
`;

export const ChartSettings = styled.div`
  margin-bottom: 54px;

  .chart-name {
    padding: 12px;

    &.active {
      background-color: ${(props) => props.theme.colors.bgBox};
      color: ${(props) => props.theme.colors.link};
      font-weight: 600;
      cursor: default;
    }
  }
`;

export const ChartFilters = styled.div`
  background-color: ${(props) => props.theme.colors.bgBox};
  padding: 24px;
  border-radius: 4px;
`;

export const ExportFormat = styled.fieldset`
  border-radius: 4px;
  border: 5px solid #eff5fb;
  padding: 24px;

  label {
    color: ${(props) => props.theme.colors.link};
  }
`;

export const CoursesWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 16px 32px;
  margin-bottom: 42px;

  .courses-container {
    position: absolute;
    z-index: 1;
    width: 430px;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    background: ${(props) => props.theme.colors.white};
    box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
    padding: 0 10px;

    .course-card {
      display: grid;
      border-bottom: 1px solid ${(props) => props.theme.colors.border};
      padding: 16px 24px;

      .info {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        color: #515151;
      }
    }
  }

  .courses-settings {
    padding: 24px;
    background-color: ${(props) => props.theme.colors.bgBox};
    border-radius: 4px;

    .setting {
      margin-bottom: 40px;
    }
  }
`;

export const CourseCardCta = styled.div`
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 4px 20px 0px rgba(104, 104, 104, 0.1);
  display: grid;
  grid-template-columns: 70px 1fr 100px;
  gap: 16px;
  padding: 16px 24px;
  align-items: center;
  margin-bottom: 16px;

  .code {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: #515151;
  }
`;

export const UserSettings = styled.div`
  .checkbox-wrapper {
    gap: 80px;

    label {
      color: ${(props) => props.theme.colors.textPrimary};
      font-size: 18px;
      line-height: 1;
    }
  }

  .user-settings {
    margin-top: 32px;
    padding: 24px;
    background-color: ${(props) => props.theme.colors.bgBox};
    border-radius: 4px;

    .select-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 40px 80px;
    }
  }
`;

export const GridSetting = styled.div`
  &.grid {
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 20px;
  }

  .chart-type-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px;
    margin: 8px 0;

    &.active {
      background-color: ${(props) => props.theme.colors.bgBox};

      .b3 {
        font-weight: 600;
      }
    }
  }
`;
